import {useMutation, useQuery} from '@tanstack/react-query';
import {
  addProjectField,
  addProjectFieldGroup,
  getProjectFieldAllDropdownLists,
  getProjectFieldDetails,
} from '../../api/endpoints/projectApi';
import {
  IAddProjectFieldGroupRequest,
  IAddProjectFieldRequest,
  IProjectFieldAllDropdownListsResponse,
} from '../../api/types/project.type';
import {AxiosError} from 'axios';

export const useProjectFieldAllDropdownLists = () => {
  return useQuery<IProjectFieldAllDropdownListsResponse, AxiosError>({
    queryKey: ['projectFieldAllDropdownLists'],
    queryFn: () => getProjectFieldAllDropdownLists(),
  });
};

export const useAddProjectFieldGroup = () => {
  return useMutation<boolean, AxiosError, IAddProjectFieldGroupRequest>({
    mutationFn: addProjectFieldGroup,
    mutationKey: ['addProjectFieldGroup'],
  });
};

export const useAddProjectField = () => {
  return useMutation<boolean, AxiosError, IAddProjectFieldRequest>({
    mutationFn: addProjectField,
    mutationKey: ['addProjectField'],
  });
};

export const useGetProjectFieldDetails = (
  projectFieldId: string,
  enabled: boolean
) => {
  return useQuery({
    queryKey: ['projectfields', projectFieldId],
    queryFn: async () => {
      return getProjectFieldDetails(projectFieldId);
    },
    enabled: enabled,
  });
};
